<script>
import { SelectListSorted } from '../patterns'
import { getIconName } from '../utils/highlights'
import SvgIcon from '~/components/SvgIcon.vue'
import highlightsIcons from '~/icons/vehicleHighlight'

export default {
  name: 'SRPHighligts',
  config: {
    title: 'Vehicle Highlights',
    facet: 'highlights',
    weight: 14
  },
  components: {
    SelectListSorted,
    SvgIcon
  },
  methods: {
    getIcon (value) {
      return highlightsIcons[getIconName(value)]
    }
  }
}
</script>

<template>
  <SelectListSorted
    facet="highlights"
    operator="AND"
    order="popularity"
  >
    <template #icon="{ value }">
      <SvgIcon
        v-if="getIcon(value)"
        class="highlight--icon"
        :src="getIcon(value)"
      />
    </template>
  </SelectListSorted>
</template>

<style lang="scss">
.highlight--icon {
  height: 24px;
  width: 24px;
}
</style>
